import styled from "styled-components";

export const Section = styled.div`
	display: flex;
	width: 100%;
`;
